import { render, staticRenderFns } from "./add-workout.vue?vue&type=template&id=072b483a&"
import script from "./add-workout.vue?vue&type=script&lang=js&"
export * from "./add-workout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports